import styles from "./todoList.module.css";
import { BiTrash } from "react-icons/bi";
const Todo = ({ todo, onDelete }) => {
  return (
    <div className={styles.container}>
      <div className={styles.todoContainer} key={todo.id}>
        <div>{todo.title}</div>
        <div>{todo.cost}</div>
        <div>{todo.description}</div>
        <div>
          <button className={styles.btn} onClick={onDelete}>
            <BiTrash />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Todo;
